import { SelectField } from "../../../components/forms/fields/SelectField";
import { Product } from "../models/product";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useGetAdditionGroups } from "../../../service/api";
import * as authSelectors from "../../auth/authSelectors";
import { useSelector } from "react-redux";
import { SpinnerBlock } from "../../common/Spinner";
import { useHandleFetchError } from "../../../error-handler";

export const ProductAdditionGroupsForm = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const formMethods = useFormContext<Product>();

  const { watch } = formMethods;
  const { replace } = useFieldArray({
    control: formMethods.control,
    name: "additionGroups",
  });
  const { data, isLoading, error } = useGetAdditionGroups(organizationKeyName);

  const options = (data || []).map((x) => ({
    label: x.name,
    value: x.id,
  }));

  useHandleFetchError(error);

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <SelectField
      isMulti
      label="Addition groups"
      helperText="Select addition groups that will be available for this product"
      closeMenuOnSelect={false}
      errorMessage={
        formMethods.getFieldState("additionGroups", formMethods.formState).error
          ?.message
      }
      onChange={(value) => {
        replace(
          (value as { value: string; label: string }[]).map((x) => {
            const group = data?.find((ag) => ag.id === x.value);
            return {
              id: x.value,
              name: group?.name || x.label,
              title: group?.title || x.label,
            };
          })
        );
      }}
      options={options}
      value={options?.filter((option) => {
        return watch("additionGroups")?.find((ag) => ag.id === option.value);
      })}
    />
  );
};
